/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["ccp-IN",[["AM","PM"]],u,[["𑄢𑄧","𑄥𑄧","𑄟𑄧","𑄝𑄪","𑄝𑄳𑄢𑄨","𑄥𑄪","𑄥𑄧"],["𑄢𑄧𑄝𑄨","𑄥𑄧𑄟𑄴","𑄟𑄧𑄁𑄉𑄧𑄣𑄴","𑄝𑄪𑄖𑄴","𑄝𑄳𑄢𑄨𑄥𑄪𑄛𑄴","𑄥𑄪𑄇𑄴𑄇𑄮𑄢𑄴","𑄥𑄧𑄚𑄨"],["𑄢𑄧𑄝𑄨𑄝𑄢𑄴","𑄥𑄧𑄟𑄴𑄝𑄢𑄴","𑄟𑄧𑄁𑄉𑄧𑄣𑄴𑄝𑄢𑄴","𑄝𑄪𑄖𑄴𑄝𑄢𑄴","𑄝𑄳𑄢𑄨𑄥𑄪𑄛𑄴𑄝𑄢𑄴","𑄥𑄪𑄇𑄴𑄇𑄮𑄢𑄴𑄝𑄢𑄴","𑄥𑄧𑄚𑄨𑄝𑄢𑄴"],["𑄢𑄧𑄝𑄨","𑄥𑄧𑄟𑄴","𑄟𑄧𑄁𑄉𑄧𑄣𑄴","𑄝𑄪𑄖𑄴","𑄝𑄳𑄢𑄨𑄥𑄪𑄛𑄴","𑄥𑄪𑄇𑄴𑄇𑄮𑄢𑄴","𑄥𑄧𑄚𑄨"]],u,[["𑄎","𑄜𑄬","𑄟","𑄃𑄬","𑄟𑄬","𑄎𑄪𑄚𑄴","𑄎𑄪","𑄃","𑄥𑄬","𑄃𑄧","𑄚𑄧","𑄓𑄨"],["𑄎𑄚𑄪","𑄜𑄬𑄛𑄴","𑄟𑄢𑄴𑄌𑄧","𑄃𑄬𑄛𑄳𑄢𑄨𑄣𑄴","𑄟𑄬","𑄎𑄪𑄚𑄴","𑄎𑄪𑄣𑄭","𑄃𑄉𑄧𑄌𑄴𑄑𑄴","𑄥𑄬𑄛𑄴𑄑𑄬𑄟𑄴𑄝𑄧𑄢𑄴","𑄃𑄧𑄇𑄴𑄑𑄮𑄝𑄧𑄢𑄴","𑄚𑄧𑄞𑄬𑄟𑄴𑄝𑄧𑄢𑄴","𑄓𑄨𑄥𑄬𑄟𑄴𑄝𑄢𑄴"],["𑄎𑄚𑄪𑄠𑄢𑄨","𑄜𑄬𑄛𑄴𑄝𑄳𑄢𑄪𑄠𑄢𑄨","𑄟𑄢𑄴𑄌𑄧","𑄃𑄬𑄛𑄳𑄢𑄨𑄣𑄴","𑄟𑄬","𑄎𑄪𑄚𑄴","𑄎𑄪𑄣𑄭","𑄃𑄉𑄧𑄌𑄴𑄑𑄴","𑄥𑄬𑄛𑄴𑄑𑄬𑄟𑄴𑄝𑄧𑄢𑄴","𑄃𑄧𑄇𑄴𑄑𑄬𑄝𑄧𑄢𑄴","𑄚𑄧𑄞𑄬𑄟𑄴𑄝𑄧𑄢𑄴","𑄓𑄨𑄥𑄬𑄟𑄴𑄝𑄧𑄢𑄴"]],[["𑄎","𑄜𑄬","𑄟","𑄃𑄬","𑄟𑄬","𑄎𑄪𑄚𑄴","𑄎𑄪","𑄃","𑄥𑄬","𑄃𑄧","𑄚𑄧","𑄓𑄨"],["𑄎𑄚𑄪𑄠𑄢𑄨","𑄜𑄬𑄛𑄴𑄝𑄳𑄢𑄪𑄠𑄢𑄨","𑄟𑄢𑄴𑄌𑄧","𑄃𑄬𑄛𑄳𑄢𑄨𑄣𑄴","𑄟𑄬","𑄎𑄪𑄚𑄴","𑄎𑄪𑄣𑄭","𑄃𑄉𑄧𑄌𑄴𑄑𑄴","𑄥𑄬𑄛𑄴𑄑𑄬𑄟𑄴𑄝𑄧𑄢𑄴","𑄃𑄧𑄇𑄴𑄑𑄮𑄝𑄧𑄢𑄴","𑄚𑄧𑄞𑄬𑄟𑄴𑄝𑄧𑄢𑄴","𑄓𑄨𑄥𑄬𑄟𑄴𑄝𑄧𑄢𑄴"]],[["𑄈𑄳𑄢𑄨𑄌𑄴𑄑𑄴𑄛𑄫𑄢𑄴𑄝𑄧","𑄈𑄳𑄢𑄨𑄌𑄴𑄑𑄛𑄴𑄘𑄧"]],0,[0,0],["d/M/yy","d MMM, y","d MMMM, y","EEEE, d MMMM, y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##,##0.###","#,##,##0%","#,##,##0.00¤","#E0"],"INR","₹","𑄃𑄨𑄚𑄴𑄘𑄨𑄠𑄚𑄴 𑄢𑄪𑄛𑄨",{"BDT":["৳"],"BYN":[u,"р."],"JPY":["JP¥","¥"],"PHP":[u,"₱"],"STD":[u,"Db"],"THB":["฿"],"TWD":["NT$"],"USD":["US$","$"]},"ltr", plural];
